module.exports = __webpack_public_path__ + "static/img/2.f1875bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/sp/2.png
// module id = RfyG
// module chunks = 0